import { PresetItemFormValue } from 'pages/Presets/PresetsCreate/PresetsCreateForm/PresetsCreateForm';

export const getEmptyPresetItem = (direction: string): PresetItemFormValue => ({
  direction,
  amount: '',
  badge: null,
  description: null,
});
